import { connect } from 'react-redux';
import StudentLoginForm from '../../components/LoginPage/StudentLoginForm';
import {
  actions as AuthActions,
  selectors as AuthSelectors,
} from '../../reducers/auth';

export const mapStateToProps = (state) => ({
  errorMessage: AuthSelectors.getErrorMessage(state),
  isLoading: AuthSelectors.getIsLoggingIn(state),
});

const mapDispatchToProps = {
  noTypeLogin: AuthActions.noTypeLogin,
  emailOnlyProviderLogin: AuthActions.emailOnlyProviderLogin,
};

export default connect(mapStateToProps, mapDispatchToProps)(StudentLoginForm);
